import * as InputGroup from 'components/atomic/molecules/input-group/input-group.styled'

export { InputGroupSkeleton } from 'components/atomic/molecules/input-group/input-group-skeleton'

export default InputGroup
